import {
  VerificationCodeProps,
  VerificationCode,
} from 'libs/ui/VerificationCode';

import { FieldType } from '../types';
import { useField } from '../useField';

interface Props
  extends FieldType,
    Omit<
      VerificationCodeProps,
      'name' | 'onChange' | 'onChangeText' | 'value' | 'type'
    > {}

export const VerificationCodeField = ({
  name,
  allowSubmit,
  onComplete,
  ...props
}: Props) => {
  const { helpers, inputProps } = useField<string | undefined>(name, {
    allowSubmit,
  });

  return (
    <VerificationCode
      {...props}
      isError={inputProps.error}
      onChange={() => helpers.setError('')}
      onComplete={(v) => {
        helpers.setValue(v);
        onComplete?.(v);
      }}
    />
  );
};
